<script setup>
  import { RouterView } from 'vue-router'
  import LegalAcceptanceModal from '@components/App/LegalAcceptanceModal.vue'
  // import { useLocalStorage } from '@vueuse/core'
  // import { useI18n } from 'vue-i18n'

  // const { locale } = useI18n({ useScope: 'global' })
  // const localeSave = useLocalStorage('lang', 'en')

  // locale.value = localeSave.value
</script>

<template>
  <router-view />
  <!-- Mounted here rather than in a layout so no authenticated route can
       render without the gate. -->
  <legal-acceptance-modal />
  <notifications
    position="top left"
    :duration="4000"
  />
</template>
